//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scheduleEventBus, SCHEDULE_EVENTS } from './scheduleEventBus';

export default {
  name: 'SessionDetailSidebar',

  props: {
    session: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openModal() {
      scheduleEventBus.$emit(SCHEDULE_EVENTS.OPEN_MODAL, { sessionUrl: this.session.sessionUrl || '' });
    },

    openShare() {
      scheduleEventBus.$emit(SCHEDULE_EVENTS.OPEN_SHARE, { triggerEl: this.$refs.shareBtn });
    },

    onPrint() {
      // Detail-print: render SessionPrintView for this session, not the schedule listing.
      scheduleEventBus.$emit(SCHEDULE_EVENTS.PRINT_SESSION, { session: this.session });
    },
  },
};
